import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai';
import logo from '../images/logo.png';

const Navbar = () => {
  const [nav, setNav] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const closeNav = () => {
    setNav(false);
  };

  return (
    <div className='fixed w-full top-0 left-0 bg-black z-50 md:z-[100] h-24 border-b border-gray-600'>
      <div className='flex justify-between items-center max-w-[1240px] mx-auto px-4 pt-3 text-white'>
        <img src={logo} alt="Logo" className='w-10 filter invert' />
        <ul className='hidden md:flex'>
          <li className='p-4'><Link to="/about">Bemutatkozás</Link></li>
          <li className='p-4'><Link to="/story">Történet</Link></li>
          <li className='p-4'><Link to="/help">Segíteni akarok</Link></li>
        </ul>
        <div onClick={handleNav} className='block md:hidden'>
            {nav ? <AiOutlineClose size={20}/> : <AiOutlineMenu size={20} />}
        </div>
      </div>
      <div onClick={closeNav} className={nav ? 'fixed inset-0' : 'hidden'}></div>
      <ul className={nav ? 'fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#000300] ease-in-out duration-500' : 'ease-in-out duration-500 fixed left-[-100%]'}>
        <img src={logo} alt="Logo" className='w-10 filter invert m-4' />
        <li className='p-4 border-b border-gray-600'><Link to="/about" onClick={closeNav}>Bemutatkozás</Link></li>
        <li className='p-4 border-b border-gray-600'><Link to="/story" onClick={closeNav}>Történet</Link></li>
        <li className='p-4'><Link to="/help" onClick={closeNav}>Segíteni akarok</Link></li>
      </ul>
    </div>
  );
};

export default Navbar;